export default "__VITE_ASSET__kysv$ktq__"